import React from 'react';
import PropTypes from 'prop-types';
import Loading from '../../../Loading';
import Price from '../../../Price/Price';
import LineItemImage from '../../../LineItemII/LineItemImage';
import Modal from '../../../Modal';
import Button from 'wonderbly-components/lib/Button';
import RichText from '../../../../components/Prismic/RichText';
import Icon from 'wonderbly-components/lib/Icon';

import './CheckoutLineItem.scss';

const CheckoutLineItem = props => {
  if (props.areItemsLoading) {
    return <Loading dark relative small />;
  }
  return (
    <React.Fragment>
      {props.hasModal &&
        <Modal
          className="checkout-order-summary-modal-wrapper"
          default={props.isModalOpen}
          isOpen={props.isModalOpen}
          modalTitle={props.modalTitle}
          modalContent={props.modalContent}
          modalCloseText={props.modalCloseText}>
          <div className="checkout-order-summary-modal">
            <div className="checkout-order-summary-modal-title">
              <span>{props.modalTitle}</span>
              <button onClick={props.onClickClose}>
                <Icon icon="delete" />
              </button>
            </div>
            <hr />
            <div className="checkout-order-summary-modal-content">
              <RichText
                fields={props.modalContent}
              />
            </div>
            <Button onClick={props.onClickClose} outlined colour="green">
              {props.modalCloseText}
            </Button>
          </div>
        </Modal>
      }
      <button className="checkout-line-item-wrapper" onClick={props.onClick}>
        <LineItemImage addons={props.addons} image={props.image} />
        <div className="checkout-line-item-content" key="line-item-content">
          <div className="checkout-line-item-title">
            {props.title}
            {props.customisationString && props.lineItemPrefix &&
              <span>{' '}{props.lineItemPrefix}{' '}</span>
            }
            {props.customisationString}
          </div>
          <span className="checkout-line-item-type">{props.type}</span>
        </div>
        <div className="checkout-line-item-price">
          {props.editItemCta &&
            <div
              className="checkout-line-item-edit">
              <span>{props.editItemCta}</span>
            </div>
          }
          <Price className="" price={props.price} />
        </div>
      </button>
      <hr />
    </React.Fragment>
  );
};

CheckoutLineItem.propTypes = {
  areItemsLoading: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.object,
  addons: PropTypes.array.isRequired,
  type: PropTypes.string.isRequired,
  price: PropTypes.object,
  customisationString: PropTypes.string,
  lineItemPrefix: PropTypes.string,
  editItemCta: PropTypes.string,
  modalTitle: PropTypes.string,
  modalContent: PropTypes.array,
  modalCloseText: PropTypes.string,
  isModalOpen: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onClickClose: PropTypes.func.isRequired,
  hasModal: PropTypes.bool,
};

export default CheckoutLineItem;



// WEBPACK FOOTER //
// ./src/client/js/view/components/MainCheckout/CheckoutOrderSummary/CheckoutLineItem/CheckoutLineItem.js